const { gql } = require('graphql-tag');

module.exports = {
  fragment: gql`
    fragment DefaultMoney on Money {
      currencyCode
      centAmount
      fractionDigits
    }
  `,
};
